export type Effect = 'appear' | 'fade_in';

export default class FullScreenIllustrationRenderOptions {
  constructor(public effect?: Effect) {}
}
